import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {makeStyles} from 'tss-react/mui';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import Checkbox from '@mui/material/Checkbox';
import EmailIcon from '@mui/icons-material/Email';
import SendIcon from '@mui/icons-material/Send';
//DS
import {openMsg, loadingModal} from 'src/redux-app';
import {SelectPlus, hooks} from 'lib.front';
import {transformacion} from 'lib.common';

import {esquemaCampos, esquemaValidacion} from './esquemas';
import useMensajeLlave from '../../../common/useMensajeLlave';
import {urlsCrm} from '../../../config/keys';
import {queryCliente} from './queries';
import {showSucces} from 'src/common/toast';
import {cmps} from './constantes';

const {denominacionCliente} = transformacion;
const {useApolloLazyQ, useValidacion} = hooks;

const useStyles = makeStyles()(theme => ({
   container: {
      marginTop: theme.spacing(2)
   },
   tabla: {
      width: '100%'
   }
}));

function EnviarMail(props) {
   const dispatch = useDispatch();
   const {classes, cx} = useStyles();
   //Modal de espera
   function openWaitModal(load) {
      dispatch(loadingModal(load));
   }
   //Modal para mensajes
   function openMsgModal(msg) {
      dispatch(openMsg(msg));
   }
   //Estados
   const {
      campos,
      existeError,
      handleOnChange,
      validacionManual,
      setCampo,
      validarTodos,
      inicializar
   } = useValidacion(esquemaCampos, esquemaValidacion);
   function getClienteCodigo(valor) {
      return valor.split('|')[0];
   }
   function getClienteEmail(valor) {
      if (valor) {
         return valor.split('|')[1];
      }
      return '';
   }

   //Data de cliente
   useEffect(() => {
      if (campos.cliente.valor && campos.cliente.valor.label) {
         setCampo('razonSocial', campos.cliente.valor.label.split('-')[1].trimStart());
         setCampo('email', getClienteEmail(campos.cliente.valor.value));
      }
   }, [campos.cliente.valor]);

   function onClickBuscar() {
      if (campos.cliente.valor && campos.cliente.valor.value !== '') {
         getCliente({variables: {codigoCliente: getClienteCodigo(campos.cliente.valor.value)}});
      }
   }
   function procesarCliente(data) {
      if (data.clienteSpu) {
         const estadosElegidos = new Array(data.clienteSpu.length).fill(true);
         setElegidos(estadosElegidos);
      }
   }
   const [getCliente, {data: dataCliente}] = useApolloLazyQ(queryCliente, {
      callbackProcesarData: procesarCliente,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });

   function onBlurValidacion(e) {
      validacionManual(e.target.name, e.target.value);
   }

   //CHECKBOXES
   const [elegidos, setElegidos] = useState([]);
   function toggleCheckBox(index) {
      let nuevoElegidos = elegidos;
      nuevoElegidos[index] = !nuevoElegidos[index];
      setElegidos(nuevoElegidos);
   }
   //Enviar Mensajes
   const [enviarMailLlave] = useMensajeLlave({
      callbackProcesarData: procesarMensajeCorrecto,
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });
   function procesarMensajeCorrecto() {
      showSucces('Correo electronico enviado correctamente.');
   }

   async function enviarEmailIndividual(dataLlave) {
      const esOkMail = await validarTodos();
      if (esOkMail) {
         const para = campos.email.valor;
         let receptores = [
            {
               email: para,
               ruc: getClienteCodigo(campos.cliente.valor.value),
               razonSocial: campos.razonSocial.valor,
               documento: `${dataLlave.tipoDoc}-${dataLlave.serieDoc}-${dataLlave.nroDoc}`,
               producto: genDenomiacionProducto(dataLlave),
               activaciones: [dataLlave.codigo]
            }
         ];
         enviarMailLlave({variables: {receptores}});
      }
   }

   async function enviarEmailTodos() {
      const esOkMail = await validarTodos();
      if (esOkMail && dataCliente && dataCliente.clienteSpu.length > 0) {
         const activacionesData = dataCliente.clienteSpu;
         const para = campos.email.valor;
         let documentos = '';
         const activaciones = await Promise.all(
            activacionesData.map(item => {
               documentos = `${documentos}${item.tipoDoc.valor}-${item.serieDoc.valor}-${item.nroDoc.valor},`;
               return `${item.codigo} (${item.producto.denominacion} ${item.presentacion.denominacion} ${item.version.denominacion})`;
            })
         );
         let receptores = [];
         const receptor = {
            email: para,
            ruc: getClienteCodigo(campos.cliente.valor.value),
            razonSocial: campos.razonSocial.valor,
            documento: documentos,
            producto: ''
         };
         receptor.activaciones = activaciones;
         receptores.push(receptor);
         enviarMailLlave({variables: {receptores}});
      }
   }

   async function enviarEmailIndividual(dataLlave) {
      const esOkMail = await validarTodos();
      if (esOkMail) {
         const para = campos.email.valor;
         let receptores = [
            {
               email: para,
               ruc: getClienteCodigo(campos.cliente.valor.value),
               razonSocial: campos.razonSocial.valor,
               documento: `${dataLlave.tipoDoc}-${dataLlave.serieDoc}-${dataLlave.nroDoc}`,
               producto: genDenomiacionProducto(dataLlave),
               activaciones: [dataLlave.codigo]
            }
         ];
         enviarMailLlave({variables: {receptores}});
      }
   }

   // Funciones
   function genDenomiacionProducto(registro) {
      const producto = registro.producto.split('-')[1];
      const presentacion = registro.presentacion.split('-')[1];
      const version = registro.version.split('-')[1];
      return `${producto} ${presentacion} ${version}`;
   }

   return (
      <Container className={cx('containerbox', classes.container)} maxWidth="md">
         <Grid container spacing={1}>
            <Grid item xs={12}>
               <Typography variant="h4" gutterBottom align="center">
                  Enviar Email
               </Typography>
            </Grid>
            <Grid container item xs={12}>
               <Grid container item xs={12} spacing={1} alignItems="center">
                  <Grid item xs={8}>
                     <SelectPlus
                        url={urlsCrm.graph}
                        name={cmps.CLIENTE}
                        label="RUC"
                        entidad="clientes"
                        campos={[
                           'codigo',
                           'nombre',
                           'apPaterno',
                           'apMaterno',
                           'razonSocial',
                           'nroDoc',
                           'email'
                        ]}
                        value={campos.cliente.valor}
                        onChange={elegido => {
                           validacionManual(cmps.CLIENTE, elegido);
                           if (elegido) {
                              validacionManual(cmps.EMAIL, getClienteEmail(elegido.value));
                           }
                        }}
                        genId={registro => {
                           return `${registro.nroDoc}|${registro.email}`;
                        }}
                        genLabel={denominacionCliente}
                        error={campos.cliente.error !== ''}
                        helperText={campos.cliente.error}
                        InputLabelProps={{shrink: true}}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        isClearable
                        excesoElementos
                        recuperarOnFocus
                        required
                        placeholder="Elija un cliente:"
                     />
                  </Grid>
                  <Grid item xs={2}>
                     <Button
                        variant="contained"
                        onClick={onClickBuscar}
                        disabled={campos.cliente === null}
                     >
                        Buscar
                     </Button>
                  </Grid>
                  <Grid item xs={6}>
                     <TextField
                        label="Razón Social"
                        name={cmps.RAZON_SOCIAL}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        required
                        value={campos.razonSocial.valor}
                        disabled={true}
                     />
                  </Grid>
                  <Grid item xs={12}>
                     <TextField
                        label="Email"
                        name={cmps.EMAIL}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        onChange={handleOnChange}
                        onBlur={onBlurValidacion}
                        value={campos.email.valor}
                        error={campos.email.error !== ''}
                        helperText={campos.email.error}
                     />
                  </Grid>
               </Grid>
               <Grid container item xs={12}>
                  {dataCliente && (
                     <TableContainer component={Paper}>
                        <Table size="small">
                           <TableHead>
                              <TableRow>
                                 {/*<TableCell></TableCell>*/}
                                 <TableCell>Producto</TableCell>
                                 <TableCell>Descripción</TableCell>
                                 <TableCell>Código de Activación</TableCell>
                                 <TableCell>
                                    <Tooltip
                                       arrow
                                       title="Enviar todos los códigos de activación por E-Mail"
                                    >
                                       <IconButton
                                          size="small"
                                          onClick={() => {
                                             enviarEmailTodos();
                                          }}
                                          disabled={existeError}
                                       >
                                          <EmailIcon />
                                       </IconButton>
                                    </Tooltip>
                                 </TableCell>
                              </TableRow>
                           </TableHead>
                           <TableBody>
                              {dataCliente.clienteSpu.map((llave, index) => {
                                 return (
                                    <TableRow key={llave.codigo}>
                                       {/*
                                       <TableCell component="th" scope="row">
                                          <Checkbox
                                             checked={elegidos[index]}
                                             onChange={() => {
                                                toggleCheckBox(index);
                                             }}
                                          />
                                       </TableCell>
                                       */}
                                       <TableCell component="th" scope="row">
                                          {`${llave.tipoDoc}-${llave.serieDoc}-${llave.nroDoc}`}
                                       </TableCell>
                                       <TableCell>{genDenomiacionProducto(llave)}</TableCell>
                                       <TableCell component="th" scope="row">
                                          {llave.codigo}
                                       </TableCell>
                                       <TableCell>
                                          <Tooltip
                                             arrow
                                             title="Enviar este codigo de activación por E-Mail"
                                          >
                                             <IconButton
                                                size="small"
                                                onClick={() => {
                                                   enviarEmailIndividual(llave);
                                                }}
                                                disabled={existeError}
                                             >
                                                <SendIcon />
                                             </IconButton>
                                          </Tooltip>
                                       </TableCell>
                                    </TableRow>
                                 );
                              })}
                           </TableBody>
                        </Table>
                     </TableContainer>
                  )}
               </Grid>
            </Grid>
         </Grid>
      </Container>
   );
}

export default EnviarMail;
